<template>
  <div id="app">
    <div class="title">实名认证</div>
    <div v-show="user.certification == 1" id="person" >

      <div class="name"><label>姓名:</label><input v-if="!user.name" v-model="personName" type="text"/><span v-if="user.name">{{user.name}}</span></div>
      <div class="ID"><label>身份证号码：</label><input v-if="!user.cardId" v-model="personNum" type="text"/><span v-if="user.cardId">{{user.cardId}}</span></div>
      <div class="name"><label>手机号:</label><input v-if="!user.phone" v-model="phone" type="text"/><span v-if="user.phone">{{user.phone}}</span></div>
      <div class="card">
        <el-upload
          name="card"
          :data="font"  
          class="avatar-uploader"
          accept=".png,.jpg" 
          action="/api/file/upload"
          style="margin-left:50px"
          :show-file-list="false"
          :auto-upload="true"
     
          :on-success="onSuccess">
          <img v-if="user.cardFront" :src="user.cardFront" class="avatar">
          <div v-else>
            <span>个人信息面</span>
            <i class="el-icon-plus avatar-uploader-icon" style="font-size:30px"></i>
          </div>
        </el-upload>

        <el-upload
          name="card"
          :data="back"  
          class="avatar-uploader"
          accept=".png,.jpg" 
          action="/api/file/upload"
          style="float:right;margin-right:50px"
          :show-file-list="false"
          :auto-upload="true"
      
          :on-success="onSuccess">
          <img v-if="user.cardBack" :src="user.cardBack" class="avatar">
          <div v-else>
            <span>国徽面</span>
            <i class="el-icon-plus avatar-uploader-icon" style="font-size:30px"></i>
          </div>
        </el-upload>
        <div class="clear_both"></div>
      </div>
      

      <div class="btn">
        <button v-if="!user.name" @click="cert" :disabled="certDisable">{{buttonText}}</button>
      </div>

        <!-- <div class="note" style="color:green;margin-top:100px;margin-left:40%">您已完成个人实名认证</div> -->
    </div>
    <div v-show="user.certification == 2" id="company" >
       <!-- <div class="note" style="color:green;margin-top:100px;margin-left:40%">您已完成企业实名认证</div> -->

      <div class="left">
        <div><label>企业全称:</label><input v-model="companyName" v-if="!user.companyName" type="text"/><span v-if="user.companyName">{{user.companyName}}</span></div>
        <div><label>社会统一信用代码:</label><input v-model="companyNum" v-if="!user.companyId" type="text"/><span v-if="user.companyId">{{user.companyId}}</span></div>
        <div><label>手机号:</label><input v-model="phone" v-if="!user.phone" type="text"/><span v-if="user.phone">{{user.phone}}</span></div>

      </div>
      <div class="right">
        <el-upload
          name="card"
          :data="company"  
          class="company-uploader"
          accept=".png,.jpg" 
          action="/api/file/upload"
          style="float:right;margin-right:30px;margin-top:30px"
          :show-file-list="false"
          :auto-upload="true"
       
          :on-success="onSuccess">
          <img v-if="user.companyPhoto" :src="user.companyPhoto" class="company">
          <div v-else>
            <span>企业营业执照</span>
            <i class="el-icon-plus avatar-uploader-icon" style="font-size:30px"></i>
          </div>
        </el-upload>
      </div>
      <div class="clear_both"></div>
      <div class="btn">
        <button v-if="!user.companyName" @click="cert" :disabled="certDisable">{{buttonText}}</button>
      </div>
    </div>
    <div v-show="user.certification == 0" id="no_auth">
    
      <div class="note">您还没进行实名认证哦</div>
      <div class="btn">
        <button class="p" @click="personCert">个人认证</button>
        <button class="c" @click="companyCert">企业认证</button>
      </div>
    </div>
  </div>
</template>



<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Authentication.css"></style>

<script>
import {certApi,userInfoApi} from '@/service/allApi'
export default {
  data(){
    return {
      user:{},
      font:{
        type:1
      },
      back:{
        type:2
      },
      personName:"",
      personNum:"",
      companyName:"",
      companyNum:"",
      phone:'',
      company:{
        type:3
      },
      type:-1,
      buttonText:"认证",
      certDisable:false,
    }
  },
  created(){
    this.user = JSON.parse( localStorage.getItem('user'))
    if(this.user.phone != null && this.user.phone!=''){
        this.phone = this.user.phone
    }
  },
  methods:{
    async cert(){
      this.buttonText = "正在认证...";
      this.certDisable = true;
      let options = {}

      if(this.phone == ''){
          alert("请填写手机号码")
          this.buttonText = "认证";
          this.certDisable = false;
          return ;
      }

      if(this.type == 1 ){
        if(!this.personName || !this.personNum){
          alert("请填写真实姓名与身份证号码")
          this.buttonText = "认证";
          this.certDisable = false;
          return ;
        }
        if(!this.user.cardFront || !this.user.cardBack){
          alert("请先上传身份证")
          this.buttonText = "认证";
          this.certDisable = false;
          return ;
        }
        options = {
          name:this.personName,
          num:this.personNum,
          cardFace:this.user.cardFront,
          cardBack:this.user.cardBack,
          type:this.type,
          company:null
        }
      }else if(this.type == 2){ 
        if(!this.companyName || !this.companyNum){
           alert("请填写真实企业名称与信用代码")
          this.buttonText = "认证";
          this.certDisable = false;
          return ;
        }
        if(!this.user.companyPhoto){
            alert("请先上传营业执照")
            this.buttonText = "认证";
            this.certDisable = false;
          return ;
        }
        options = {
          name:this.companyName,
          num:this.companyNum,
          cardFace:null,
          cardBack:null,
          type:this.type,
          company:this.user.companyPhoto,
          phone:this.phone
        }
      }
      const res = await certApi(options)
   
      if(res.data.code == 100 ){
        alert("认证成功");
        //认证成功重新加载
        userInfoApi().then((res2)=>{
          const code = res2.data.code
          if(code == 100){
            this.user = res2.data.data
            localStorage.setItem("user",JSON.stringify(res2.data.data))
          }
        })
      }else{
        alert(res.data.msg);
      }

      this.buttonText = "认证";
      this.certDisable = false;
    },
    personCert(){
      this.user.certification =1 
      this.type = 1 
    },
    companyCert(){
       this.user.certification =2
      this.type = 2
    },

    onSuccess(response,file,fileList){
      if(response.data.type == 1 ){
        if(response.data.url){
          this.user.cardFront = response.data.url
        }
      }else if(response.data.type == 2 ){
        if(response.data.url){
          this.user.cardBack = response.data.url
        }
      }else if(response.data.type == 3 ){
        if(response.data.url){
          this.user.companyPhoto = response.data.url
        }
      }
    }
  }
  
}
</script>



// WEBPACK FOOTER //
// src/components/iframe/Authentication.vue